import { BaseResponse, TableList } from '@/types/common';
import axiosInstance from './axiosInstance';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

export enum ArtistVerifyStatus {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 2,
}

export interface ArtistVerifySearchParams {
  certificationId?: string;
  suppId?: string;
  userName?: string;
  userEmail?: string;
  createDateStart?: string;
  createDateEnd?: string;
  operatorName?: string;
  status?: ArtistVerifyStatus;
  pageSize: number;
  currentPage: number;
}

export interface ArtistVerify {
  certificationId: string;
  userId: string;
  suppId: string;
  imageUrl: string;
  userName: string;
  userEmail: string;
  status: ArtistVerifyStatus;
  processTime: string;
  createTime: string;
  operatorName: string;
}

export const getArtistVerifyList = async (params: ArtistVerifySearchParams) => {
  const resp = await axiosInstance.post<BaseResponse<TableList<ArtistVerify>>>(
    `${baseUrl}/api/certification/v1/pageList`,
    params
  );
  return resp.data;
};

export interface ArtistVerifyDetail extends Omit<ArtistVerify, 'imageUrl'> {
  imageUrls: string[];
  introduction: string;
}

export const getArtistVerifyDetail = async (certificationId: string) => {
  const resp = await axiosInstance.get<BaseResponse<ArtistVerifyDetail>>(
    `${baseUrl}/api/certification/v1/detail?certificationId=${certificationId}`
  );
  return resp.data;
};

export const approveArtistVerify = async (certificationIds: string[]) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/api/certification/v1/approve`,
    {
      certificationIds,
    }
  );
  return resp.data;
};

// 0-未达艺术标准，1-认证造假，2-艺术家身份失效，3-假证件/假证明，4-其它
export enum ArtistVerifyRejectReason {
  NOT_REACH_ARTIST_STANDARD = 0,
  CERTIFICATION_FRAUD = 1,
  ARTIST_IDENTITY_INVALID = 2,
  FAKE_DOCUMENT_OR_FAKE_PROOF = 3,
  OTHER = 4,
}

export interface RejectArtistVerifyParams {
  certificationIds: string[];
  rejectReason: ArtistVerifyRejectReason;
  rejectRemark?: string;
}

export const rejectArtistVerify = async (params: RejectArtistVerifyParams) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/api/certification/v1/reject`,
    params
  );
  return resp.data;
};

export const cancelArtistVerify = async (params: RejectArtistVerifyParams) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/api/certification/v1/cancel`,
    params
  );
  return resp.data;
};
